/**
 * Decide which card-flip variant to use at app boot.
 *
 * **Why this exists:** Firefox fails to honor `backface-visibility: hidden`
 * correctly in the reveal component's DOM ancestry. A full GSAP PoC in
 * Week 1 confirmed that the bug is at Firefox's CSS compositor layer, not
 * the animation engine. This function picks between the production 3D
 * flip (Chrome/Safari) and a 2D fallback gesture (Firefox).
 *
 * Kill-switch: set `FLIP_2D_FORCE_FIREFOX` to `false` when Firefox
 * ships a fix for the compositor bug. The feature-query alone is
 * insufficient because Firefox reports preserve-3d support honestly
 * while still mis-compositing.
 */
export const FLIP_2D_FORCE_FIREFOX = true;

export function detectFlipMode(): '2d' | '3d' {
  const supportsNo3D =
    typeof CSS !== 'undefined' &&
    typeof CSS.supports === 'function' &&
    CSS.supports('not (transform-style: preserve-3d)');

  const isFirefox =
    typeof navigator !== 'undefined' &&
    navigator.userAgent.includes('Firefox');

  return supportsNo3D || (FLIP_2D_FORCE_FIREFOX && isFirefox) ? '2d' : '3d';
}
